<template>
  <div class="inspection-main">
    <div class="inspection-wrap">
      <header class="header">
        <div class="logo">
          <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745819464041_header-title-bj.png" />
        </div>
      </header>

      <infoBar @gotoPage="gotoPage" :inspectionData="props.inspectionData" />

      <div class="content">
        <ul class="btns">
          <li @click="addReport">
            <el-image fit="contain" src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-05-05/1746415841446_1694587448576.png" />
            <p>年度报告</p>
          </li>
          <li>
            <el-image fit="contain" src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-05-05/1746415885374_1694587452863.png" />
            <p>其他自行公示信息填报</p>
          </li>
          <li>
            <el-image fit="contain" src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-05-05/1746416022258_1694587460630.png" />
            <p>解散事由信息填报</p>
          </li>
          <li>
            <el-image fit="contain" src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-05-05/1746415885374_1694587452863.png" />
            <p>注销公告填报</p>
          </li>
          <li>
            <el-image fit="contain" src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-05-05/1746416022258_1694587460630.png" />
            <p>名称转让及授权信息填报</p>
          </li>
          <li>
            <el-image fit="contain" src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-05-05/1746416022258_1694587460630.png" />
            <p>营业执照作废声明填报</p>
          </li>
          <li>
            <el-image fit="contain" src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-05-05/1746415841446_1694587448576.png" />
            <p>公司和农专合并、分立填报</p>
          </li>
          <li>
            <el-image fit="contain" src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-05-05/1746416022258_1694587460630.png" />
            <p>公司减少注册资本填报</p>
          </li>
          <li>
            <el-image fit="contain" src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-05-05/1746416022258_1694587460630.png" />
            <p>市场主体终止歇业填报</p>
          </li>
          <li>
            <el-image fit="contain" src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-05-05/1746416141645_1694587457661.png" />
            <p>填报须知</p>
          </li>
        </ul>

        <h6 class="tit">年度报告管理</h6>

        <el-table class="el-table-s1" :data="tableData" :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }" border>
          <el-table-column label="序号" type="index" width="60" />
          <el-table-column label="年份" width="227">
            <template #default="{ row }">{{ row.reportYear }}年度报告</template>
          </el-table-column>
          <el-table-column label="最后修改日期" width="227">
            <template #default="{ row }">{{ dateCnStr(row.lastModifyDate) }}</template>
          </el-table-column>
          <el-table-column label="状态" width="227">
            <template #default="{ row }">{{ row.publicStatus == 1 ? "已公示" : "" }}</template>
          </el-table-column>
          <el-table-column label="公示日期" width="227">
            <template #default="{ row }">{{ dateCnStr(row.publicDate) }}</template>
          </el-table-column>
          <el-table-column label="操作">
            <template #default="{ row }">
              <el-button style="color: #cfa95e" link @click="gotoPage('form')">修改</el-button>
              <el-button style="color: #cfa95e" link @click="gotoPage('preview')">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <addReportDialog ref="addReportDialogRef" :inspectionData="props.inspectionData" @submit="addReportDialogSubmit" />
  </div>
</template>

<script setup>
import dayjs from "dayjs";
import infoBar from "../cmp/infoBar.vue";
import addReportDialog from "../cmp/addReportDialog.vue";

const props = defineProps({
  inspectionData: {
    required: true,
    type: Object,
  },
});

const tableData = computed(() => {
  try {
    return props.inspectionData.reportData.lastModifyDate ? [props.inspectionData.reportData] : [];
  } catch (e) {
    return [];
  }
});

const checkRule = inject("checkRule");

// 增加报告
const addReportDialogRef = ref(null);

const addReport = () => {
  addReportDialogRef.value.open();
};

const addReportDialogSubmit = (data) => {
  if (data.reportYear) {
    gotoPage("form");
  }
};

const emits = defineEmits(["gotoPage"]);

const gotoPage = (page) => {
  emits("gotoPage", page);
};

function dateCnStr(str) {
  if (dayjs(str).$d != "Invalid Date") {
    return dayjs(str).format("YYYY年MM月DD日");
  }
}
</script>

<style scoped lang="scss">
.inspection-main {
  background-color: #fbf8ef;
  display: flex;
  flex-direction: column;
  height: 100%;

  .inspection-wrap {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;

    .header {
      flex: 0 0 auto;
      overflow: hidden;
      border-top: 10px solid #ab812d;
      height: 100px;
      background: #ffffff url(https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745818808900_bj.png) no-repeat right top;
      border-bottom: 1px solid #e0dddd;

      .logo {
        width: 1200px;
        margin: 0 auto;
        height: 100%;
        display: flex;
        align-items: center;
      }
    }

    .content {
      height: 100%;
      overflow: hidden;
      width: 1200px;
      margin: 20px auto;
      background-color: #ffffff;
      overflow-y: auto;
      padding: 32px;
      box-sizing: border-box;

      .btns {
        display: grid;
        justify-content: space-between;
        grid-template-columns: repeat(auto-fill, 150px);
        grid-gap: 12px;

        li {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 150px;
          cursor: pointer;

          .el-image {
            position: relative;
            overflow: hidden;
            width: 50px;
            height: 50px;
            margin: 12px auto;
          }

          p {
            width: 85px;
            text-align: center;
            color: #333333;
          }
        }
      }

      .tit {
        margin-top: 50px;
        margin-bottom: 20px;
        position: relative;
        display: flex;
        align-items: center;
        font-weight: 700;
        color: #87550f;
        font-size: 18px;

        &::before {
          content: "";
          width: 6px;
          height: 16px;
          background: #87550f;
          margin-right: 12px;
          display: inline-block;
        }
      }
    }

    :deep(.el-table-s1) {
      width: 100%;
      box-shadow: 0 0 0 0.5px #dfe4ed;

      thead {
        th {
          background-color: #eae3db !important;
          color: #87550f !important;
          border: 0 !important;

          .cell {
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
